<template>
<v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="300"
    >
      <v-card>
        <v-card-title class="headline">
          Выберите систему ТК
        </v-card-title>
        <v-card-text>
          <p>
            Вы собираетесь загрузить файл отчета. Выберите источник отчета.
          </p>
          <v-select
                color="primary"
                prepend-icon="mdi-web"
                v-model="cardSystem"
                :items="cardSystems"
                label="Система ТК"
                outlined
                required
                >
                </v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="dialog = false"
          >
            Отмена
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="onClick"
          >
            Продолжить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: {
    dialog: Boolean
  },
  computed: {
  },
  data: () => ({
    cardSystem: 'Опти-24',
    cardSystems: ['Опти-24', 'Shell', 'Neste Oil', 'Роснефть']
  }),
  watch: {
  },
  components: {
  },
  methods: {
    onClick () {
      this.$emit('onDialogClosed', { cardSystem: this.cardSystem })
    }
  },
  mounted () {
  }
  /* eslint-enable */
}
</script>
